import { LIST_REQUIRED_STATUSES } from "../../constants/required-values";

const state = {
  missingEmailFieldError: {
    title: "Missing field for Email Address",
    message: "Please add at least 1 field for email address!"
  },
  invalidInputError: {
    title: "A required field is missing or a field is invalid.",
    message: "Please review the form for error messages!"
  },
  missingBookingTimeError: {
    title: "Booking time is missing",
    message: "Please add booking time (Start Time and End Time)!"
  },
  missingSignatureError: {
    title: "A document is not signed",
    message: "Please review the form for error messages and sign all documents!"
  },
  inputConditionError: {
    title: "An input field is invalid",
    message: "There is an input field which is invalid"
  },
  builderNoFieldError: {
    title: "There is no field for the builder",
    message: "Please add at least one field!"
  },
  exclusiveOptionsUseSameValue: {
    title: "Cannot use same option between {0} and {1}",
    message: "Please unselect option(s) {2} in {0} or {1}"
  },
  missingDependencyObjectError: {
    title: "Please add more {0}!",
    message: "You must have at least {1} {0}"
  },
  missingExperienceError: {
    title: "Experience is lacking",
    message: "You must have at least 1 experience."
  },
  missingStatusError: {
    title: "Statuses is lacking",
    message: `${LIST_REQUIRED_STATUSES.join(" and ")} are required statuses`
  },
  duplicateStatusError: {
    title: "Statuses is duplicated",
    message: "There are some statuses which are duplicated"
  },
  duplicateModelError: {
    title: "Multi fields using the same model",
    message: "There is a model which is assigned to at least 2 fields"
  },
  duplicateChecklistItemError: {
    title: "Statuses is duplicated",
    message: "There are some items which are duplicated"
  },
  duplicateEmployerTypeError: {
    title: "Employer type is duplicated",
    message: "There are some employer type which are duplicated"
  },
  duplicateCandidateTypeError: {
    title: "Candidate type is duplicated",
    message: "There are some candidate type which are duplicated"
  },
  invalidImageFileTypeError: {
    title: "Sorry, that file type is invalid!",
    message: "Please upload a PNG or JPG image."
  },
  invalidDocFileTypeError: {
    title: "Sorry, that file type is invalid!",
    message: "Please upload a DOC or DOCX or PDF file."
  },
  emptyFileError: {
    title: "File is empty!",
    message: "Please upload a non empty file"
  },
  fileSizeExceedLimitError: {
    title: "File too big!",
    message: "Please upload a file with a size below the maximum upload size."
  },
  invalidInputFile: {
    title: "Invalid File",
    message: "Invalid input file"
  },
  missingResumeError: {
    title: "Your professional childcare resume is missing",
    message: "Please upload your professional childcare resume"
  },
  endDateBeforeStartDateError: {
    title: "End date must be after start date",
    message: "Please change start date or end date"
  },
  endHourBeforeStartHourError: {
    title: "End time must be after start time",
    message: "Please change start time or end time"
  },
  bookingDurationTooShortError: {
    title: "Bookings must be at least {0} hours.",
    message: "Please change start time or end time"
  },
  missingProfilePictureError: {
    title: "Your profile picture is missing",
    message: "Please upload a recent photo of yourself!"
  },
  noTextSelect: {
    title: "No text selected",
    message: "Please select some text"
  },
  submitReferenceError: {
    title: "Your application has been submitted! BUT",
    message:
      "There was an error processing your references. Can you please email them to us? Thanks!"
  },
  submitError: {
    title: "Failed to submit your application",
    message: "There was an error processing your application"
  },
  missingItemInJobStatusList: {
    title: "Missing item in status list",
    message: "Status {0} is required"
  },
  hasIncompleteSection: {
    title: "There is an incomplete section",
    message: "Section {0} is incomplete. Please update that section"
  },
  passwordUnmatchError: {
    title: "Passwords do not match."
  },
  missingAddressErrorDialog: {
    title: "Unable to find nearby Candidates",
    message: "Job is missing a full address. To search for candidates Edit Job and fill missing address info"
  },
  profileBuilderInUsed: {
    title: "The profile builder is in used",
    message: "The profile builder is being used by the profile builder {0}.\nPlease remove that profile builder first"
  },
  missingSignatureErrorDialog: {
    title: "A signature is missing",
    message: "Please type your name to sign"
  },
  missingRequiredFieldSigningErrorDialog: {
    title: "A required field is missing",
    message: "Please fill all of the required fields (Please check the red border fields)"
  },
  userExistedErrorDialog: {
    innerHtml: `
                <h2>It looks like you are already in our system!</h2>
                <h4 class="error-message main-message">
                Please <a href='{0}/login/{1}'>log into your dashboard</a> to continue, or contact us if you have questions. Thank you!
                </h4>
                `,
  }
};

const mutations = {};

const actions = {};

const getters = {
  missingEmailFieldError(state) {
    return state.missingEmailFieldError;
  },
  invalidInputError(state) {
    return state.invalidInputError;
  },
  missingBookingTimeError(state) {
    return state.missingBookingTimeError;
  },
  missingSignatureError(state) {
    return state.missingSignatureError;
  },
  inputConditionError(state) {
    return state.inputConditionError;
  },
  builderNoFieldError(state) {
    return state.builderNoFieldError;
  },
  exclusiveOptionsUseSameValue(state) {
    return state.exclusiveOptionsUseSameValue;
  },
  missingDependencyObjectError(state) {
    return state.missingDependencyObjectError;
  },
  missingExperienceError(state) {
    return state.missingExperienceError;
  },
  missingStatusError(state) {
    return state.missingStatusError;
  },
  duplicateStatusError(state) {
    return state.duplicateStatusError;
  },
  duplicateChecklistItemError(state) {
    return state.duplicateChecklistItemError;
  },
  duplicateEmployerTypeError(state) {
    return state.duplicateEmployerTypeError;
  },
  duplicateCandidateTypeError(state) {
    return state.duplicateCandidateTypeError;
  },
  duplicateModelError(state) {
    return state.duplicateModelError;
  },
  invalidImageFileTypeError(state) {
    return state.invalidImageFileTypeError;
  },
  invalidDocFileTypeError(state) {
    return state.invalidDocFileTypeError;
  },
  emptyFileError(state) {
    return state.emptyFileError;
  },
  fileSizeExceedLimitError(state) {
    return state.fileSizeExceedLimitError;
  },
  invalidInputFile(state) {
    return state.invalidInputFile;
  },
  missingResumeError(state) {
    return state.missingResumeError;
  },
  endHourBeforeStartHourError(state) {
    return state.endHourBeforeStartHourError;
  },
  endDateBeforeStartDateError(state) {
    return state.endDateBeforeStartDateError;
  },
  bookingDurationTooShortError(state) {
    return state.bookingDurationTooShortError;
  },
  missingProfilePictureError(state) {
    return state.missingProfilePictureError;
  },
  noTextSelect(state) {
    return state.noTextSelect;
  },
  submitReferenceError(state) {
    return state.submitReferenceError;
  },
  submitError(state) {
    return state.submitError;
  },
  missingItemInJobStatusList(state) {
    return state.missingItemInJobStatusList;
  },
  hasIncompleteSection(state) {
    return state.hasIncompleteSection;
  },
  passwordUnmatchError(state) {
    return state.passwordUnmatchError;
  },
  missingAddressErrorDialog(state) {
    return state.missingAddressErrorDialog;
  },
  profileBuilderInUsed(state) {
    return state.profileBuilderInUsed;
  },
  missingSignatureErrorDialog(state) {
    return state.missingSignatureErrorDialog;
  },
  missingRequiredFieldSigningErrorDialog(state) {
    return state.missingRequiredFieldSigningErrorDialog;
  },
  userExistedErrorDialog(state) {
    return state.userExistedErrorDialog;
  }

};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/error-dialog-content.js